(function ($) {

    const MAP_SELECTOR = '.sase_map_v2';
    const LOCATION_CLASS = 'sase_map_v2__location';
    const MAP_ACTIVE_CLASS = 'active';
    const LOCATION_ACTIVE_CLASS = 'active';

    $(MAP_SELECTOR).each(function () {
        const mapElement = this;
        const tooltipElement = mapElement.querySelector('.sase_map_v2__tooltip');
        const wavesElement = mapElement.querySelector('.sase_map_v2__waves');

        const dots = window.sase_map_v2_locations;

        dots.forEach((location) => {
            el = mapElement.querySelector('#dot_' + Number.parseInt(location.dot))
            if (!el) {
                return;
            }

            location.el = el;
            location.el.classList.add(LOCATION_CLASS);

            let chainAnimationInterval;
            location.el.addEventListener('mouseenter', function (event) {
                const pageWidth = document.documentElement.clientWidth;
                const svgWidth = mapElement.querySelector('svg').clientWidth;
                const svgHeight = mapElement.querySelector('svg').clientHeight;
                const topPadding = pageWidth < 1360 ? 137 : 142;

                setTimeout(() => mapElement.classList.add(MAP_ACTIVE_CLASS));

                // Tooltip
                tooltipElement.innerHTML = '<b>' + location.city + '</b><br>' + location.country;
                tooltipElement.classList.add(LOCATION_ACTIVE_CLASS);
                tooltipElement.style.setProperty('left', event.x + 'px');
                tooltipElement.style.setProperty('top', (event.offsetY - 5 - tooltipElement.offsetHeight + topPadding) + 'px');

                // Waves effect
                const dotElement = event.target.getBBox();
                const sideGap = (pageWidth - svgWidth) / 2;
                const ratio = svgWidth / 1356;
                const positionX = (dotElement.x - 214.575 + dotElement.width / 2) * ratio;
                const positionY = (dotElement.y - 51.898 - 2 + dotElement.height / 2) * ratio;

                wavesElement.classList.add('animate');
                wavesElement.style.setProperty('left', positionX + sideGap + 'px');
                wavesElement.style.setProperty('top', positionY + topPadding + 'px');

                chainAnimationInterval = chainAnimation(event.target);
            });

            location.el.addEventListener('mouseleave', function (event) {
                clearInterval(chainAnimationInterval);

                mapElement.classList.remove(MAP_ACTIVE_CLASS);

                dots.forEach((otherDot) => otherDot.el.classList.remove('active'));
                syncAnimation();

                tooltipElement.classList.remove(LOCATION_ACTIVE_CLASS);
                tooltipElement.innerHTML = '';

                wavesElement.classList.remove('animate');
            });
        });
    });

    function chainAnimation(targetDot) {
        const animationRadiusStep = 50;
        const animationRadiusLimit = 1400;

        let radius = animationRadiusStep;
        const chainAnimationInterval = setInterval(() => {
            if (radius > animationRadiusLimit) {
                // Reached limit.
                clearInterval(chainAnimationInterval);
                return;
            }

            radius += animationRadiusStep;

            const dots = document.querySelectorAll('.sase_map_v2__location');
            dots.forEach((otherDot) => {
                if (otherDot.id === targetDot.id) {
                    return;
                }

                if (isInRadius([otherDot.getBBox().x, otherDot.getBBox().y], [targetDot.getBBox().x, targetDot.getBBox().y], radius) === -1) {
                    otherDot.classList.add('active');
                }
            });
        }, 100);

        return chainAnimationInterval;
    }

    function syncAnimation() {
        const dots = document.querySelectorAll('.sase_map_v2__location');
        dots.forEach((el) => {
            el.style.animation = 'none';
            setTimeout(() => el.style.animation = '', 200);
        });
    }

    function isInRadius(target, center, radius) {
        const lhs = Math.pow(center[0] - target[0], 2) + Math.pow(center[1] - target[1], 2);
        const rhs = Math.pow(radius, 2);

        return lhs < rhs ? -1 : (lhs === rhs ? 0 : 1);
    }

})(window.jQuery);
